var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"id":_vm.name,"max":_vm.maxVal,"min":_vm.minVal,"name":_vm.name,"required":"","type":"number"},domProps:{"value":_vm.inputVal},on:{"change":function($event){return _vm.checkValue(+$event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }